import React from "react";
import { ArrowUpRight } from "lucide-react";
import { ChatBar } from "../../features/kquant/components/ChatBar";

export function HeroSection() {
  return (
    <div className="flex flex-col items-center justify-center pt-16 pb-12 relative z-10">
      <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-10 tracking-wide text-center">
        Build, edit, and share quant strategies using natural language.
      </h1>

      <div className="relative group w-full max-w-2xl">
        {/* <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-500 via-blue-500 to-teal-400 rounded-full opacity-75 blur-sm group-hover:opacity-100 transition duration-200" />
        <div className="relative flex items-center bg-white rounded-full px-6 py-3 border border-slate-200 shadow-sm">
          <input
            type="text"
            placeholder="Ask K-Quant to build a quant workflow for US tech stocks"
            className="w-full bg-transparent text-slate-700 outline-none placeholder-slate-400 text-sm"
          />
          <button
            type="button"
            className="bg-blue-600 hover:bg-blue-500 text-white p-2 rounded-full transition-colors ml-2"
          >
            <ArrowUpRight size={16} />
          </button>
        </div> */}
        <ChatBar Icon={ArrowUpRight} />
      </div>
    </div>
  );
}
